(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vardoren-contact-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.vdContactCarouselReady === 'true') return;

      const track = section.querySelector('[data-vd-contact-carousel]');
      const slides = Array.from(section.querySelectorAll('.vd-contact-intro__card'));
      const dots = Array.from(section.querySelectorAll('[data-vd-contact-dot]'));

      if (!track || slides.length < 2 || dots.length !== slides.length) return;

      section.dataset.vdContactCarouselReady = 'true';

      const updateDots = () => {
        const currentIndex = slides.reduce((closestIndex, slide, index) => {
          const currentDistance = Math.abs(slides[closestIndex].offsetLeft - track.offsetLeft - track.scrollLeft);
          const nextDistance = Math.abs(slide.offsetLeft - track.offsetLeft - track.scrollLeft);
          return nextDistance < currentDistance ? index : closestIndex;
        }, 0);

        dots.forEach((dot, index) => {
          if (index === currentIndex) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      let animationFrame;
      track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(animationFrame);
        animationFrame = window.requestAnimationFrame(updateDots);
      }, { passive: true });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          track.scrollTo({
            left: slides[index].offsetLeft - track.offsetLeft,
            behavior: 'smooth'
          });
        });
      });

      updateDots();
    };

    document.querySelectorAll('.vd-contact-intro').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('.vd-contact-intro'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vardoren-home-products"] && !Shopify.designMode) return;
  try {
    
  const initializeVardorenProductCarousel = (root) => {
    if (root.dataset.vdCarouselReady === 'true') return;

    const track = root.querySelector('[data-vd-track]');
    const previous = root.querySelector('[data-vd-previous]');
    const next = root.querySelector('[data-vd-next]');
    const pagination = root.parentElement.querySelector('[data-vd-pagination]');

    if (!track || !previous || !next || !pagination) return;
    root.dataset.vdCarouselReady = 'true';

    let dots = [];

    const metrics = () => {
      const card = track.querySelector('.vd-home-products__card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
      const maximum = Math.max(track.scrollWidth - track.clientWidth, 0);
      return { maximum, step };
    };

    const buildDots = () => {
      const { maximum, step } = metrics();
      const cardCount = track.querySelectorAll('.vd-home-products__card').length;
      const count = maximum > 2 ? Math.min(cardCount, Math.round(maximum / Math.max(step, 1)) + 1) : 1;
      if (dots.length === count) return;
      pagination.replaceChildren();
      dots = Array.from({ length: count }, (_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'vd-home-products__dot';
        dot.setAttribute('aria-label', `Afficher la page ${index + 1} du carrousel produits`);
        dot.addEventListener('click', () => {
          const current = metrics();
          const left = Math.min(index * current.step, current.maximum);
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
        pagination.appendChild(dot);
        return dot;
      });
    };

    const update = () => {
      buildDots();
      const { maximum } = metrics();
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maximum - 2;
      const active = maximum > 0 ? Math.round((track.scrollLeft / maximum) * (dots.length - 1)) : 0;
      dots.forEach((dot, index) => dot.setAttribute('aria-current', index === active ? 'true' : 'false'));
    };

    const move = (direction) => {
      const { step } = metrics();
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  };

  const initializeVardorenProductCarousels = (scope = document) => {
    scope.querySelectorAll('[data-vd-carousel]').forEach(initializeVardorenProductCarousel);
  };

  const initializeVardorenTouchPreviews = (scope = document) => {
    scope.querySelectorAll('.vd-home-products__touch-preview').forEach((button) => {
      if (button.dataset.vdTouchPreviewReady === 'true') return;
      button.dataset.vdTouchPreviewReady = 'true';

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const card = button.closest('.vd-home-products__card');
        if (!card) return;

        const showSecondImage = !card.classList.contains('is-previewing-second');
        card.classList.toggle('is-previewing-second', showSecondImage);
        button.setAttribute('aria-pressed', showSecondImage ? 'true' : 'false');
        button.setAttribute('aria-label', showSecondImage ? 'Voir la première photo' : 'Voir la deuxième photo');
      });
    });
  };

  initializeVardorenProductCarousels();
  initializeVardorenTouchPreviews();
  document.addEventListener('shopify:section:load', (event) => {
    initializeVardorenProductCarousels(event.target);
    initializeVardorenTouchPreviews(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vardoren-product-before-after"] && !Shopify.designMode) return;
  try {
    
  const initVardorenComparisons = (root = document) => {
    root.querySelectorAll('[data-vd-compare]').forEach((comparison) => {
      if (comparison.dataset.vdCompareReady === 'true') return;
      comparison.dataset.vdCompareReady = 'true';
      const range = comparison.querySelector('.vd-product-compare__range');
      if (!range) return;
      range.addEventListener('input', () => {
        comparison.style.setProperty('--vd-compare-position', `${range.value}%`);
      });
    });
  };

  initVardorenComparisons();
  document.addEventListener('shopify:section:load', (event) => initVardorenComparisons(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vardoren-room-visualizer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vardoren-room-visualizer')) {
    customElements.define('vardoren-room-visualizer', class extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('[data-vd-room-dialog]');
        this.stage = this.querySelector('[data-vd-room-stage]');
        this.roomPhoto = this.querySelector('[data-vd-room-photo]');
        this.productImage = this.querySelector('[data-vd-room-product]');
        this.empty = this.querySelector('[data-vd-room-empty]');
        this.processing = this.querySelector('[data-vd-room-processing]');
        this.fileInputs = [...this.querySelectorAll('[data-vd-room-file]')];
        this.cameraPanel = this.querySelector('[data-vd-room-camera-panel]');
        this.cameraVideo = this.querySelector('[data-vd-room-camera-video]');
        this.cameraStream = null;
        this.scaleInput = this.querySelector('[data-vd-room-scale]');
        this.scaleOutput = this.querySelector('[data-vd-room-scale-output]');
        this.adjust = this.querySelector('[data-vd-room-adjust]');
        this.compare = this.querySelector('[data-vd-room-compare]');
        this.status = this.querySelector('[data-vd-room-status]');
        this.downloadButton = this.querySelector('[data-vd-room-download]');
        this.pointers = new Map();
        this.cache = new Map();
        this.state = { x: 0, y: 0, scale: .7, rotation: 0 };
        this.dragOrigin = null;
        this.pinchOrigin = null;
        this.roomUrl = null;
        this.pickerActive = false;
      }

      connectedCallback() {
        this.querySelector('[data-vd-room-open]')?.addEventListener('click', () => this.open());
        this.querySelector('[data-vd-room-close]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-vd-room-return]')?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog?.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') this.close();
        });
        this.fileInputs.forEach((input) => {
          input.addEventListener('click', () => {
            this.pickerActive = true;
          });
          input.addEventListener('change', (event) => this.loadRoom(event));
        });
        this.querySelector('[data-vd-room-start-camera]')?.addEventListener('click', () => this.startCamera());
        this.querySelector('[data-vd-room-camera-cancel]')?.addEventListener('click', () => this.stopCamera());
        this.querySelector('[data-vd-room-camera-capture]')?.addEventListener('click', () => this.captureCamera());
        window.addEventListener('focus', () => {
          if (!this.pickerActive) return;
          this.open(false);
        });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden && this.pickerActive) this.open(false);
        });
        this.scaleInput?.addEventListener('input', () => {
          this.state.scale = Number(this.scaleInput.value) / 100;
          this.scaleOutput.value = this.scaleInput.value + ' %';
          this.renderTransform();
        });
        this.querySelectorAll('[data-vd-room-rotate]').forEach((button) => {
          button.addEventListener('click', () => {
            this.state.rotation += Number(button.dataset.vdRoomRotate);
            this.renderTransform();
          });
        });
        this.querySelector('[data-vd-room-reset]')?.addEventListener('click', () => this.resetTransform());
        this.querySelectorAll('[data-vd-room-variant]').forEach((button) => {
          button.addEventListener('click', () => this.selectVariant(button));
        });
        this.querySelectorAll('[data-vd-room-view]').forEach((button) => {
          button.addEventListener('click', () => this.setView(button.dataset.vdRoomView));
        });
        this.downloadButton?.addEventListener('click', () => this.downloadPreview());
        this.stage?.addEventListener('pointerdown', (event) => this.pointerDown(event));
        this.stage?.addEventListener('pointermove', (event) => this.pointerMove(event));
        this.stage?.addEventListener('pointerup', (event) => this.pointerUp(event));
        this.stage?.addEventListener('pointercancel', (event) => this.pointerUp(event));
        this.stage?.addEventListener('wheel', (event) => this.zoomWithWheel(event), { passive: false });
      }

      open(syncVariant = true) {
        if (syncVariant) this.syncVariant();
        if (this.dialog) {
          this.dialog.hidden = false;
          this.dialog.focus({ preventScroll: true });
        }
        document.documentElement.style.overflow = 'hidden';
      }

      close() {
        this.stopCamera();
        if (this.dialog) this.dialog.hidden = true;
        this.pickerActive = false;
        this.unlockPage();
      }

      unlockPage() {
        document.documentElement.style.removeProperty('overflow');
      }

      syncVariant() {
        const selected = document.querySelector('input[type="radio"]:checked');
        const title = selected?.value;
        const button = [...this.querySelectorAll('[data-vd-room-variant]')].find((item) => item.dataset.variantTitle === title);
        if (button) this.selectVariant(button, false);
      }

      async selectVariant(button, syncProduct = true) {
        this.querySelectorAll('[data-vd-room-variant]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (syncProduct) {
          const title = button.dataset.variantTitle;
          const productOption = [...document.querySelectorAll('input[type="radio"]')].find((input) => input.value === title);
          productOption?.click();
        }
        this.productImage.dataset.source = button.dataset.source;
        if (this.roomPhoto && !this.roomPhoto.hidden) await this.prepareProduct();
      }

      async loadRoom(event) {
        const file = event.target.files?.[0];
        this.pickerActive = false;
        this.open(false);
        if (!file || (file.type && !file.type.startsWith('image/'))) {
          this.status.textContent = 'Choisissez une photo au format image.';
          return;
        }
        this.status.textContent = 'Préparation de votre pièce…';
        if (this.roomUrl) URL.revokeObjectURL(this.roomUrl);
        try {
          this.roomUrl = await this.readRoomPhoto(file);
          await this.useRoomPhoto(this.roomUrl);
        } catch (error) {
          this.status.textContent = 'Cette photo ne peut pas être lue. Essayez un autre fichier.';
        } finally {
          event.target.value = '';
        }
      }

      async startCamera() {
        this.open(false);
        const mediaDevices = navigator.mediaDevices;
        const getUserMedia = mediaDevices?.getUserMedia?.bind(mediaDevices);
        if (!getUserMedia) {
          this.status.textContent = 'La caméra intégrée n’est pas disponible. Utilisez « Choisir une photo ».';
          return;
        }
        this.stopCamera();
        this.cameraPanel.hidden = false;
        this.cameraVideo.hidden = true;
        this.status.textContent = 'Autorisez l’accès à la caméra pour photographier votre pièce.';
        try {
          this.cameraStream = await getUserMedia({
            video: {
              facingMode: { ideal: 'environment' },
              width: { ideal: 1920 },
              height: { ideal: 1080 }
            },
            audio: false
          });
          this.cameraVideo.srcObject = this.cameraStream;
          this.cameraVideo.hidden = false;
          await this.cameraVideo.play();
          this.status.textContent = 'Caméra prête.';
        } catch (error) {
          this.stopCamera();
          this.status.textContent = 'Accès à la caméra refusé ou indisponible. Utilisez « Choisir une photo ».';
        }
      }

      async captureCamera() {
        const width = this.cameraVideo?.videoWidth;
        const height = this.cameraVideo?.videoHeight;
        if (!width || !height) {
          this.status.textContent = 'La caméra n’est pas encore prête. Réessayez dans un instant.';
          return;
        }
        const maxSide = 1800;
        const ratio = Math.min(1, maxSide / Math.max(width, height));
        const canvas = document.createElement('canvas');
        canvas.width = Math.max(1, Math.round(width * ratio));
        canvas.height = Math.max(1, Math.round(height * ratio));
        canvas.getContext('2d').drawImage(this.cameraVideo, 0, 0, canvas.width, canvas.height);
        const photo = canvas.toDataURL('image/jpeg', .9);
        this.stopCamera();
        this.roomUrl = photo;
        try {
          await this.useRoomPhoto(photo);
        } catch (error) {
          this.status.textContent = 'La photo n’a pas pu être préparée. Réessayez.';
        }
      }

      stopCamera() {
        this.cameraStream?.getTracks().forEach((track) => track.stop());
        this.cameraStream = null;
        if (this.cameraVideo) {
          this.cameraVideo.pause();
          this.cameraVideo.srcObject = null;
          this.cameraVideo.hidden = false;
        }
        if (this.cameraPanel) this.cameraPanel.hidden = true;
      }

      async useRoomPhoto(source) {
        this.roomPhoto.src = source;
        await this.waitForImage(this.roomPhoto);
        this.roomPhoto.hidden = false;
        this.empty.hidden = true;
        this.compare.hidden = false;
        this.enableControls(true);
        this.resetTransform();
        await this.prepareProduct();
        this.status.textContent = 'Votre pièce et Lumo sont prêts à être visualisés.';
      }

      readRoomPhoto(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.addEventListener('load', () => resolve(reader.result), { once: true });
          reader.addEventListener('error', () => reject(reader.error), { once: true });
          reader.addEventListener('abort', () => reject(new Error('Lecture annulée.')), { once: true });
          reader.readAsDataURL(file);
        });
      }

      waitForImage(image) {
        if (image.complete && image.naturalWidth > 0) return Promise.resolve();
        return new Promise((resolve, reject) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', reject, { once: true });
        });
      }

      async optimiseRoomPhoto(file) {
        const maxSide = 1800;
        if (!('createImageBitmap' in window)) return URL.createObjectURL(file);
        let bitmap;
        try {
          bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' });
          const ratio = Math.min(1, maxSide / Math.max(bitmap.width, bitmap.height));
          if (ratio === 1) {
            bitmap.close?.();
            return URL.createObjectURL(file);
          }
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(bitmap.width * ratio));
          canvas.height = Math.max(1, Math.round(bitmap.height * ratio));
          const context = canvas.getContext('2d');
          context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
          bitmap.close?.();
          const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', .88));
          if (!blob) throw new Error('La réduction de la photo a échoué.');
          return URL.createObjectURL(blob);
        } catch (error) {
          bitmap?.close?.();
          return URL.createObjectURL(file);
        }
      }

      enableControls(enabled) {
        this.adjust?.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        this.adjust?.querySelectorAll('input, button').forEach((control) => { control.disabled = !enabled; });
        if (this.downloadButton) this.downloadButton.disabled = !enabled;
      }

      async prepareProduct() {
        const source = this.productImage.dataset.source;
        if (!source) return;
        this.processing.hidden = false;
        this.productImage.hidden = true;
        try {
          const processed = this.cache.get(source) || await this.removeConnectedBackground(source);
          this.cache.set(source, processed);
          this.productImage.src = processed;
          await this.productImage.decode();
          this.productImage.hidden = false;
          this.setView('after');
        } catch (error) {
          this.productImage.src = source;
          this.productImage.hidden = false;
        } finally {
          this.processing.hidden = true;
        }
      }

      removeConnectedBackground(source) {
        return new Promise((resolve, reject) => {
          const image = new Image();
          image.crossOrigin = 'anonymous';
          image.onload = () => {
            const maxSide = 800;
            const ratio = Math.min(1, maxSide / Math.max(image.naturalWidth, image.naturalHeight));
            const width = Math.max(1, Math.round(image.naturalWidth * ratio));
            const height = Math.max(1, Math.round(image.naturalHeight * ratio));
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const context = canvas.getContext('2d', { willReadFrequently: true });
            context.drawImage(image, 0, 0, width, height);
            const frame = context.getImageData(0, 0, width, height);
            const pixels = frame.data;
            const total = width * height;
            const seen = new Uint8Array(total);
            const stack = new Int32Array(total);
            let stackSize = 0;
            const push = (index) => {
              if (index >= 0 && index < total && !seen[index]) stack[stackSize++] = index;
            };
            const background = (index) => {
              const offset = index * 4;
              const red = pixels[offset];
              const green = pixels[offset + 1];
              const blue = pixels[offset + 2];
              const maximum = Math.max(red, green, blue);
              const minimum = Math.min(red, green, blue);
              return pixels[offset + 3] === 0 || ((red + green + blue) / 3 > 221 && maximum - minimum < 34);
            };
            for (let x = 0; x < width; x += 1) {
              push(x);
              push((height - 1) * width + x);
            }
            for (let y = 1; y < height - 1; y += 1) {
              push(y * width);
              push(y * width + width - 1);
            }
            while (stackSize) {
              const index = stack[--stackSize];
              if (seen[index]) continue;
              seen[index] = 1;
              if (!background(index)) continue;
              pixels[index * 4 + 3] = 0;
              const x = index % width;
              if (x > 0) push(index - 1);
              if (x < width - 1) push(index + 1);
              if (index >= width) push(index - width);
              if (index < total - width) push(index + width);
            }
            context.putImageData(frame, 0, 0);
            let left = width;
            let top = height;
            let right = 0;
            let bottom = 0;
            for (let y = 0; y < height; y += 1) {
              for (let x = 0; x < width; x += 1) {
                if (pixels[(y * width + x) * 4 + 3] > 8) {
                  left = Math.min(left, x);
                  right = Math.max(right, x);
                  top = Math.min(top, y);
                  bottom = Math.max(bottom, y);
                }
              }
            }
            if (right <= left || bottom <= top) {
              resolve(canvas.toDataURL('image/png'));
              return;
            }
            const padding = Math.round(Math.max(right - left, bottom - top) * .025);
            left = Math.max(0, left - padding);
            top = Math.max(0, top - padding);
            right = Math.min(width - 1, right + padding);
            bottom = Math.min(height - 1, bottom + padding);
            const cropped = document.createElement('canvas');
            cropped.width = right - left + 1;
            cropped.height = bottom - top + 1;
            cropped.getContext('2d').drawImage(canvas, left, top, cropped.width, cropped.height, 0, 0, cropped.width, cropped.height);
            resolve(cropped.toDataURL('image/png'));
          };
          image.onerror = reject;
          image.src = source;
        });
      }

      resetTransform() {
        this.state = { x: 0, y: 0, scale: .7, rotation: 0 };
        if (this.scaleInput) this.scaleInput.value = '70';
        if (this.scaleOutput) this.scaleOutput.value = '70 %';
        this.renderTransform();
      }

      renderTransform() {
        if (!this.productImage) return;
        this.productImage.style.transform = 'translate(-50%, -50%) translate(' + this.state.x + 'px, ' + this.state.y + 'px) scale(' + this.state.scale + ') rotate(' + this.state.rotation + 'deg)';
      }

      pointerDown(event) {
        if (this.productImage?.hidden || event.target.closest('button')) return;
        this.stage.setPointerCapture(event.pointerId);
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (this.pointers.size === 1) {
          this.dragOrigin = { x: event.clientX, y: event.clientY, offsetX: this.state.x, offsetY: this.state.y };
          this.productImage.classList.add('is-dragging');
        }
        if (this.pointers.size === 2) {
          const points = [...this.pointers.values()];
          this.pinchOrigin = { distance: Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y), scale: this.state.scale };
        }
      }

      pointerMove(event) {
        if (!this.pointers.has(event.pointerId)) return;
        this.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        if (this.pointers.size === 1 && this.dragOrigin) {
          this.state.x = this.dragOrigin.offsetX + event.clientX - this.dragOrigin.x;
          this.state.y = this.dragOrigin.offsetY + event.clientY - this.dragOrigin.y;
          this.renderTransform();
        }
        if (this.pointers.size === 2 && this.pinchOrigin) {
          const points = [...this.pointers.values()];
          const distance = Math.hypot(points[1].x - points[0].x, points[1].y - points[0].y);
          this.state.scale = Math.max(.35, Math.min(1.35, this.pinchOrigin.scale * distance / this.pinchOrigin.distance));
          this.scaleInput.value = String(Math.round(this.state.scale * 100));
          this.scaleOutput.value = Math.round(this.state.scale * 100) + ' %';
          this.renderTransform();
        }
      }

      pointerUp(event) {
        this.pointers.delete(event.pointerId);
        this.productImage?.classList.remove('is-dragging');
        this.dragOrigin = null;
        this.pinchOrigin = null;
      }

      zoomWithWheel(event) {
        if (this.productImage?.hidden) return;
        event.preventDefault();
        const next = this.state.scale + (event.deltaY < 0 ? .04 : -.04);
        this.state.scale = Math.max(.35, Math.min(1.35, next));
        this.scaleInput.value = String(Math.round(this.state.scale * 100));
        this.scaleOutput.value = Math.round(this.state.scale * 100) + ' %';
        this.renderTransform();
      }

      setView(view) {
        this.querySelectorAll('[data-vd-room-view]').forEach((button) => button.classList.toggle('is-active', button.dataset.vdRoomView === view));
        if (this.productImage) this.productImage.style.visibility = view === 'before' ? 'hidden' : 'visible';
      }

      async downloadPreview() {
        if (!this.roomPhoto?.src || !this.productImage?.src) return;
        const stageRect = this.stage.getBoundingClientRect();
        const roomRect = this.roomPhoto.getBoundingClientRect();
        const productRect = this.productImage.getBoundingClientRect();
        const ratio = Math.min(2, Math.max(1, 1600 / stageRect.width));
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(stageRect.width * ratio);
        canvas.height = Math.round(stageRect.height * ratio);
        const context = canvas.getContext('2d');
        const roomNaturalRatio = this.roomPhoto.naturalWidth / this.roomPhoto.naturalHeight;
        const stageRatio = stageRect.width / stageRect.height;
        let sourceWidth = this.roomPhoto.naturalWidth;
        let sourceHeight = this.roomPhoto.naturalHeight;
        let sourceX = 0;
        let sourceY = 0;
        if (roomNaturalRatio > stageRatio) {
          sourceWidth = this.roomPhoto.naturalHeight * stageRatio;
          sourceX = (this.roomPhoto.naturalWidth - sourceWidth) / 2;
        } else {
          sourceHeight = this.roomPhoto.naturalWidth / stageRatio;
          sourceY = (this.roomPhoto.naturalHeight - sourceHeight) / 2;
        }
        context.drawImage(this.roomPhoto, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, canvas.width, canvas.height);
        context.save();
        const centerX = (productRect.left - stageRect.left + productRect.width / 2) * ratio;
        const centerY = (productRect.top - stageRect.top + productRect.height / 2) * ratio;
        context.translate(centerX, centerY);
        context.rotate(this.state.rotation * Math.PI / 180);
        context.drawImage(this.productImage, -productRect.width * ratio / 2, -productRect.height * ratio / 2, productRect.width * ratio, productRect.height * ratio);
        context.restore();
        const link = document.createElement('a');
        link.download = 'apercu-lumo-vardoren.png';
        link.href = canvas.toDataURL('image/png', .95);
        link.click();
        this.status.textContent = 'Votre aperçu Lumo a été téléchargé.';
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vardoren-tv-guide"] && !Shopify.designMode) return;
  try {
    
  const initializeVardorenTvGuide = (root) => {
    if (root.dataset.guideReady === 'true') return;
    root.dataset.guideReady = 'true';

    const form = root.querySelector('.vd-tv-guide__form');
    const panel = root.querySelector('[data-guide-panel]');
    const startButton = root.querySelector('[data-guide-start]');
    const steps = Array.from(root.querySelectorAll('[data-guide-step]'));
    const result = root.querySelector('[data-guide-result]');
    const nextButton = root.querySelector('[data-guide-next]');
    const backButton = root.querySelector('[data-guide-back]');
    const restartButton = root.querySelector('[data-guide-restart]');
    const currentLabel = root.querySelector('[data-guide-current]');
    const progress = root.querySelector('[data-guide-progress]');
    const matchesContainer = root.querySelector('[data-guide-matches]');
    const sizeBands = {
      '24–42 pouces': { min: 24, max: 42 },
      '42–55 pouces': { min: 42, max: 55 },
      '55–70 pouces': { min: 55, max: 70 },
      '70 pouces et plus': { min: 70, max: Infinity }
    };
    let currentStep = 0;


    const setExpanded = (expanded, moveFocus = true) => {
      panel.hidden = !expanded;
      startButton.setAttribute('aria-expanded', String(expanded));
      startButton.textContent = expanded ? root.dataset.closeLabel : root.dataset.startLabel;
      if (expanded && moveFocus) {
        requestAnimationFrame(() => (result.hidden ? steps[currentStep].querySelector('legend') : result.querySelector('h3'))?.focus());
      } else if (moveFocus) {
        startButton.focus();
      }
    };

    const checkedInStep = () => steps[currentStep].querySelector('input:checked');

    const showStep = (index) => {
      currentStep = index;
      steps.forEach((step, stepIndex) => { step.hidden = stepIndex !== currentStep; });
      result.hidden = true;
      form.hidden = false;
      backButton.hidden = currentStep === 0;
      nextButton.disabled = !checkedInStep();
      nextButton.firstChild.textContent = currentStep === steps.length - 1 ? 'Voir mon orientation ' : 'Continuer ';
      currentLabel.textContent = String(currentStep + 1);
      progress.style.width = `${((currentStep + 1) / steps.length) * 100}%`;
      steps[currentStep].querySelector('legend').focus?.();
    };

    const updateMotionChoices = () => {
      const placement = form.querySelector('input[name^="guide-placement-"]:checked')?.value;
      root.querySelectorAll('[data-guide-motion]').forEach((choice) => {
        const allowed = choice.dataset.guideMotion.split(' ').includes(placement);
        choice.hidden = !allowed;
        const input = choice.querySelector('input');
        input.disabled = !allowed;
        if (!allowed) input.checked = false;
      });
    };

    const renderMatches = (band, motion) => {
      matchesContainer.replaceChildren();
      const modelsByUrl = new Map();
      root.querySelectorAll('[data-guide-model]').forEach((element) => {
        const model = {
          min: Number(element.dataset.min),
          max: Number(element.dataset.max),
          motion: element.dataset.motion,
          title: element.dataset.title,
          url: element.dataset.url,
          image: element.dataset.image
        };
        if (model.url) modelsByUrl.set(model.url, model);
      });
      const matches = Array.from(modelsByUrl.values())
        .filter((model) => model.motion === motion && model.min <= band.max && model.max >= band.min)
        .map((model) => ({ ...model, coversBand: model.min <= band.min && model.max >= band.max }))
        .sort((a, b) => Number(b.coversBand) - Number(a.coversBand) || (Number.isFinite(band.max) ? (Math.min(b.max, band.max) - Math.max(b.min, band.min)) - (Math.min(a.max, band.max) - Math.max(a.min, band.min)) : b.max - a.max) || a.min - b.min)
        .slice(0, 3);

      matches.forEach((model) => {
        const card = document.createElement('a');
        card.className = 'vd-tv-guide__match';
        card.href = model.url;
        if (model.image) {
          const image = document.createElement('img');
          image.className = 'vd-tv-guide__match-image';
          image.src = model.image;
          image.alt = '';
          image.loading = 'lazy';
          card.append(image);
        }
        const copy = document.createElement('span');
        copy.className = 'vd-tv-guide__match-copy';
        const name = document.createElement('strong');
        name.textContent = model.title;
        const range = document.createElement('small');
        range.textContent = `Écrans de ${model.min} à ${model.max} pouces`;
        const note = document.createElement('em');
        note.textContent = model.coversBand ? 'Diagonale dans toute la plage choisie' : 'Vérifiez votre taille exacte';
        copy.append(name, range, note);
        card.append(copy);
        matchesContainer.append(card);
      });
      return matches.length;
    };

    const displayResult = () => {
      const size = form.querySelector('input[name^="guide-size-"]:checked')?.value || '';
      const placement = form.querySelector('input[name^="guide-placement-"]:checked')?.value;
      const motion = form.querySelector('input[name^="guide-motion-"]:checked')?.value;
      const verified = form.querySelector('input[name^="guide-check-"]:checked')?.value === 'yes';
      const title = result.querySelector('[data-guide-result-title]');
      const text = result.querySelector('[data-guide-result-text]');
      const link = result.querySelector('[data-guide-result-link]');
      const band = sizeBands[size];
      let resultTitle = 'Supports TV sur pied à explorer';

      if (placement === 'wall' && motion === 'fixed') resultTitle = 'Supports muraux fixes à explorer';
      if (placement === 'wall' && motion === 'tilt') resultTitle = 'Supports muraux inclinables à explorer';
      if (placement === 'wall' && motion === 'articulated') resultTitle = 'Supports muraux articulés à explorer';
      if (placement === 'stand' && motion === 'mobile') resultTitle = 'Supports TV mobiles à explorer';

      const count = band ? renderMatches(band, motion) : 0;
      title.textContent = count ? resultTitle : 'Aucun modèle précis à vous proposer pour ce choix';
      text.textContent = count
        ? verified
          ? `Pour un écran de ${size}, voici des modèles à comparer. Contrôlez les pouces exacts, le poids maximal et le VESA sur chaque fiche produit.`
          : `Pour un écran de ${size}, voici des pistes. Relevez d’abord sa diagonale exacte, son poids sans pied et son VESA avant de choisir.`
        : 'Nous n’avons pas identifié de modèle pour cette combinaison de taille et d’usage. Vous pouvez consulter tous les supports TV ou recommencer avec un autre choix.';
      link.href = root.dataset.collectionUrl;
      form.hidden = true;
      result.hidden = false;
      result.querySelector('h3').focus?.();
    };

    form.addEventListener('change', (event) => {
      if (event.target.name?.startsWith('guide-placement-')) updateMotionChoices();
      nextButton.disabled = !checkedInStep();
    });

    nextButton.addEventListener('click', () => {
      if (!checkedInStep()) return;
      if (currentStep === steps.length - 1) {
        displayResult();
        return;
      }
      showStep(currentStep + 1);
    });

    backButton.addEventListener('click', () => {
      if (currentStep > 0) showStep(currentStep - 1);
    });

    restartButton.addEventListener('click', () => {
      form.reset();
      updateMotionChoices();
      showStep(0);
    });

    startButton.addEventListener('click', () => {
      setExpanded(panel.hidden);
    });

    showStep(0);
    setExpanded(false, false);
  };

  const initializeAllVardorenTvGuides = (scope = document) => {
    scope.querySelectorAll('[data-vd-tv-guide]').forEach(initializeVardorenTvGuide);
  };

  initializeAllVardorenTvGuides();
  document.addEventListener('shopify:section:load', (event) => initializeAllVardorenTvGuides(event.target));

  } catch(e) { console.error(e); }
})();
})();
